import { environment } from './../../../../../environments/environment';
import { Component, ElementRef, Inject, Input, OnInit, ViewChild } from '@angular/core';
import { FundraiserService, StorageService, UtilService, VariablesService } from '../../../../shared/services';
import { loading_gif } from '../../../../fundraiser/models/image-loader';

interface IDonor {
  name: string;
  donoravtar: any;
  initials: string;
}
@Component({
  selector: 'app-support-card',
  templateUrl: './support-card.component.html',
  styleUrls: [`./support-card.component.scss`]
})
export class SupportCardComponent implements OnInit {

  @Input() public donations;
  @Input() public cardType;
  @Input() public fundraiser;
  @Input() public campaingUrl;
  @ViewChild('profilePic', { static: true }) public profilePicRef: ElementRef<HTMLInputElement>;
  @ViewChild('profileSrc', { static: true }) public profileSrcRef: ElementRef<HTMLImageElement>;
  donor: IDonor;
  userdata;
  status;
  isLoggedIn;
  shareeCardBg = '/assets/images/sharee-card-bg.png';
  constructor(
    public utilService: UtilService,
    public storageService: StorageService,
    public variablesService: VariablesService,
    public fundraiserService: FundraiserService
  ) { }

  ngOnInit() {
    this.fromatResponse();
    this.variablesService.userData.subscribe({
      next: (res) => {
        this.userdata = res;
      }
    });
    this.utilService.isLoggedIn.subscribe({ next: res => this.isLoggedIn = res });
  }
  fromatResponse() {
    this.donor = {
      name: this.getName(),
      donoravtar: this.donations[0].donoravtar,
      initials: this.setName(this.getName()),
    };
    this.status = this.donations[0].is_anonymous;
  }
  getName() {
    return this.donations[0].name ? this.donations[0].name : this.donations[0].donor.full_name;
  }
  /**Set Name Initials  */
  setName(name) {
    return this.utilService.getInitialsOfName(name);
  }
  /**get currency icon */
  // getCurrency(currency) {
  //   return this.utilService.getCurrencyIcon(currency);
  // }
  /**Move to Comment input */
  moveToComment() {
    this.variablesService.commentCard.next(true);
  }
  /**Set user anonymous */
  updateAnonymousStatus() {
    if (this.donations && this.donations.length) {
      const payload = {
        is_anonymous: undefined
      };
      payload.is_anonymous = this.status === 1 ? 0 : 1;
      this.fundraiserService.updateAnonymous(payload, this.userdata.id, this.donations[0].order_id).subscribe((res: any) => {
        this.status = +res.data.is_anonymous;
      });
    }
  }
  /**Change profile pic */
  profilePicOnCick() {
    this.profilePicRef.nativeElement.value = '';
    this.profilePicRef.nativeElement.click();
  }
  /**File upload change event */
  changeProfilePic(event) {
    const file: File = event.target.files[0];
    const error = this.utilService.onFileChange(event);
    if (!error.error) {
      this.profileSrcRef.nativeElement.src = loading_gif;
      this.profileSrcRef.nativeElement.style.width = 'auto';
      this.fundraiserService.uploadProfilePic(this.userdata.id, file).subscribe((res: any) => {
        this.donor.donoravtar = {
          cdn_path: res.cdn_path
        };
        this.profileSrcRef.nativeElement.src = res.cdn_path;
        this.profileSrcRef.nativeElement.style.width = '100%';
      }, () => {
        this.profileSrcRef.nativeElement.src = this.donor.donoravtar.cdn_path;
      });
    }
  }

}
